import { wxJsapiSignature } from '@/api/user';
// #ifdef H5
import * as wx from 'weixin-js-sdk'
// #endif
// 销量格式化
export function formatNumber(value) {
	if (value <= 100) {
		return value.toString();
	} else if (value < 1000) {
		return Math.floor(value / 100) * 100 + '+';
	} else if (value < 10000) {
		return Math.floor(value / 100) * 100 + '+';
	} else {
		return (value / 10000).toFixed(1) + 'w+';
	}
}
export function setGoodTypeLabel(type) {
	let goodTypeColor = 'linear-gradient( to right, #ff810c, #ff810c)'
	if(type == 2) {
		goodTypeColor = "linear-gradient( to right, #AA93FF, #E83CFF)"
	}else if(type == 3) {
		goodTypeColor = "linear-gradient( to right, #FF9838, #FF663C)"
	}else if(type == 12) {
		goodTypeColor = "linear-gradient( to right, #21B1FF, #0055FF)"
	}
	return goodTypeColor;
}

export function initWxConfig() {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/micromessenger/i) == 'micromessenger') {
		console.log('是微信客户端', location.href.split('#')[0])
		wxJsapiSignature({
			shareUrl: location.href.split('#')[0],
		}).then(res => {
			wx.config({ //初始化配置
				debug: false, // 是否开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: res.appId, // 必填，公众号的唯一标识
				timestamp: res.timestamp, // 必填，生成签名的时间戳
				nonceStr: res.nonceStr, // 必填，生成签名的随机串
				signature: res.signature, // 必填，签名，
				jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData',
					'checkJsApi', 'hideAllNonBaseMenuItem', 'showMenuItems', 'openAddress'], // 必填，需要使用的JS接口列表
				openTagList:['wx-open-launch-weapp'],
			});
			wx.ready(function(){
				console.log('ready')
			  // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
			});
			wx.error(function(error){
				console.log(error)
			  // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
			});
		})
	} else {
		// console.log('不是微信客户端')
		uni.showToast({
			title: "请在小程序或APP内操作",
			icon: "none"
		})
	}
}